<template>
  <swiper
    :modules="modules"
    :autoplay="{ delay: 3500, disableOnInteraction: false }"
    :loop="true"
    :grabCursor="true"
    v-bind="swiperProps"
  >
    <swiper-slide v-for="(item, s) in items" :key="s">
      <img
        :src="item.src"
        :alt="`senator-${s},nft,nft game,argons,solanart,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art`"
        :class="{ 'relative z-10': overlay }"
      />
      <div
        v-if="overlay"
        class="bg-black bg-opacity-50 text-center text-white capitalize absolute inset-0 z-20 overflow-hidden transition-opacity ease-in-out duration-300 opacity-0 hover:opacity-100 flex justify-center items-center"
      >
        <div>
          <h5 class="mb-2">{{ item.name }}</h5>
          <h6>{{ item.position }}</h6>
          <p class="font-light text-sm my-2">{{ item.description }}</p>
          <a
            v-if="item.href"
            :href="item.href"
            target="_blank"
            class="swiper-no-swiping my-2 p-4 block underline"
          >
            profile link
          </a>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import { Autoplay, EffectCards, EffectCoverflow } from "swiper"

import "swiper/css"
import "swiper/css/effect-cards"
import "swiper/css/effect-coverflow"

export default {
  name: "swiperComponent",
  props: {
    items: { type: Array, default: () => [] },
    swiperProps: { type: Object, default: () => ({}) },
    overlay: { type: Boolean, default: false },
  },
  components: { Swiper, SwiperSlide },
  data: () => ({
    modules: [Autoplay, EffectCards, EffectCoverflow],
  }),
}
</script>
